/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Freebies_Headings_CurrentInputs */

const id_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Gratis Saat Ini`)
};

const ms_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan Percuma Semasa`)
};

const da_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuværende Gratis Spil`)
};

const de_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle kostenlose Spiele`)
};

const en_us2_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Free Games`)
};

const es_es2_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratis actuales`)
};

const es_mx2_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratis actuales`)
};

const fil_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasalukuyang Libreng Laro`)
};

const fr_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeux gratuits actuels`)
};

const it_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giochi gratuiti attuali`)
};

const hu_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelenlegi ingyenes játékok`)
};

const nl_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huidige gratis games`)
};

const no_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nåværende gratis spill`)
};

const pl_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualne darmowe gry`)
};

const pt_br2_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos grátis atuais`)
};

const pt_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos grátis atuais`)
};

const ro_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jocuri gratuite curente`)
};

const fi_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nykyiset ilmaispelit`)
};

const sv_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuella gratis spel`)
};

const vi_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game miễn phí hiện tại`)
};

const tr_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mevcut Ücretsiz Oyunlar`)
};

const cs_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuální hry zdarma`)
};

const bg_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущи безплатни игри`)
};

const ru_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущие бесплатные игры`)
};

const uk_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поточні безкоштовні ігри`)
};

const ar_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الألعاب المجانية الحالية`)
};

const hi_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान मुफ़्त गेम`)
};

const th_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมฟรีปัจจุบัน`)
};

const ja_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の無料ゲーム`)
};

const zh_cn2_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前免费游戏`)
};

const zh_hant1_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前免費遊戲`)
};

const ko_freebies_headings_current = /** @type {(inputs: Freebies_Headings_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 무료 게임`)
};

/**
* | output |
* | --- |
* | "Current Free Games" |
*
* @param {Freebies_Headings_CurrentInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const freebies_headings_current = /** @type {((inputs?: Freebies_Headings_CurrentInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freebies_Headings_CurrentInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_freebies_headings_current(inputs)
	if (locale === "ms") return ms_freebies_headings_current(inputs)
	if (locale === "da") return da_freebies_headings_current(inputs)
	if (locale === "de") return de_freebies_headings_current(inputs)
	if (locale === "en-US") return en_us2_freebies_headings_current(inputs)
	if (locale === "es-ES") return es_es2_freebies_headings_current(inputs)
	if (locale === "es-MX") return es_mx2_freebies_headings_current(inputs)
	if (locale === "fil") return fil_freebies_headings_current(inputs)
	if (locale === "fr") return fr_freebies_headings_current(inputs)
	if (locale === "it") return it_freebies_headings_current(inputs)
	if (locale === "hu") return hu_freebies_headings_current(inputs)
	if (locale === "nl") return nl_freebies_headings_current(inputs)
	if (locale === "no") return no_freebies_headings_current(inputs)
	if (locale === "pl") return pl_freebies_headings_current(inputs)
	if (locale === "pt-BR") return pt_br2_freebies_headings_current(inputs)
	if (locale === "pt") return pt_freebies_headings_current(inputs)
	if (locale === "ro") return ro_freebies_headings_current(inputs)
	if (locale === "fi") return fi_freebies_headings_current(inputs)
	if (locale === "sv") return sv_freebies_headings_current(inputs)
	if (locale === "vi") return vi_freebies_headings_current(inputs)
	if (locale === "tr") return tr_freebies_headings_current(inputs)
	if (locale === "cs") return cs_freebies_headings_current(inputs)
	if (locale === "bg") return bg_freebies_headings_current(inputs)
	if (locale === "ru") return ru_freebies_headings_current(inputs)
	if (locale === "uk") return uk_freebies_headings_current(inputs)
	if (locale === "ar") return ar_freebies_headings_current(inputs)
	if (locale === "hi") return hi_freebies_headings_current(inputs)
	if (locale === "th") return th_freebies_headings_current(inputs)
	if (locale === "ja") return ja_freebies_headings_current(inputs)
	if (locale === "zh-CN") return zh_cn2_freebies_headings_current(inputs)
	if (locale === "zh-Hant") return zh_hant1_freebies_headings_current(inputs)
	return ko_freebies_headings_current(inputs)
});
export { freebies_headings_current as "freebies.headings.current" }